<template>
    <CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
            <div class="container-fluid">
                <form id="FormProveedores" role="form" method="post" autocomplete="off" onSubmit="return false">
                    <CList @FiltrarC="Recuperar" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">

                        <template slot="Filtros">
                            <div class="col-auto">
                                <label class="col-form-label text-primary">Por</label>
                            </div>
                            <div class="col-auto">
                                <select @change="Recuperar" v-model="Filtro.IdProductoCategoria" class="form-select form-control-search">
                                    <option value="">Todos</option>
                                    <option v-for="(item,index) in Categorias" :key="index" :value="item.IdProductoCategoria">{{item.Nombre}}</option>
                                </select>
                            </div>
                        </template>

                        <template slot="header">
                            <th :class="StyleTh+' text-center'">#</th>
                            <th :class="StyleTh">Nombre Comercial</th>
                            <th :class="StyleTh">Acciones</th>
                        </template>
                        <template slot="body">
                            <tr v-for="(lista,index) in Proveedores" :key="index">
                                <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
					            <td><h6 :class="StylePr">{{lista.NombreComercial}}</h6></td>
                                <td v-if="BndMostrarBotones" class="align-middle text-end">
                                    <button v-show="lista.ShowButton" class="btn btn-link text-primary px-3 mb-0 mr-1" @click="SeleccionarProveedor(lista)">
                                        <i class="fas fa-check-circle text-primary me-2" aria-hidden="true"></i> Agregar
                                    </button>
                                </td>
                            </tr>
                            <CSinRegistros :pContIF="Proveedores.length" :pColspan="4"></CSinRegistros>
                        </template>
                    </CList>
                </form>
            </div>
        </template>
    </CLoader>
</template>
<script>
import Configs from '@/helpers/VarConfig.js';
export default{
    name: 'FormProveedores',
    props:['poBtnSave','objProveedoresSeleccionados'],
    data(){
        return{
            ConfigLoad:{
                ShowLoader: false,
                ClassLoad: false,
            },
            Emit: this.poBtnSave.EmitSeccion,
			masks:{ input: 'YYYY-MM-DD'}, // quitar sino lleva fecha
            ConfigList:{
                BtnNewShow:false,
                ShowTitleFirst: false,
                ShowTitleEnd:   false,
                ShowLoader: false,
                ShowFooter: false,
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
                IdProductoCategoria:""
                /*Anio: moment(new Date()).format('YYYY'),*/
            },
            segurity: {},
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
            Proveedores:[],
            BndMostrarBotones:false,
            Categorias:[]
        }
    },
    methods: {
        Recuperar(){
            this.BndMostrarBotones=false
            this.ConfigList.ShowLoader = true;

            this.$http.get("proveedores",{
                params:{
                    NombreComercial: this.Filtro.Nombre,
                    Entrada: this.Filtro.Entrada,
                    Pag: this.Filtro.Pagina,
                    IdProductoCategoria:this.Filtro.IdProductoCategoria
                }
            }).then((res) => {
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.Proveedores     = res.data.data.data;
                this.Proveedores.map((el)=>{return el.ShowButton=true;})
                //this.segurity           = res.data.segurity;
            }).finally(()=>{
                this.FiltrarBoton();
                this.ConfigList.ShowLoader = false;
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar(){

        },
        // PROPIO
        SeleccionarProveedor(item){
            this.bus.$emit('SeleccionarProveedor',item);
        },
        FiltrarBoton(){
            if (this.objProveedoresSeleccionados.length>0) {
                this.Proveedores.forEach(element => {
                    let BndCambio=this.objProveedoresSeleccionados.some((el)=>{return el.IdProveedor==element.IdProveedor});
                    if (BndCambio) {
                        element.ShowButton=false;
                    }
                });
            }
            this.BndMostrarBotones=true;
        },
        async ListaCategorias(){
            await this.$http.get("productosCategoria/simple"
            ).then((res)=>{
                this.Categorias=res.data.data
            })
        }
    },
    created() {
        this.ListaCategorias();
        this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            // this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            // this.Limpiar();
            this.Recuperar();
        });
    }
}
</script>